import { useState, useEffect } from "react";
import { FF } from "../shared";

const AUTH_KEY  = "qc_auth";
const PASSWORD  = "sofia0120";

export default function AuthGate({ children }) {
  const [authed,  setAuthed]  = useState(false);
  const [input,   setInput]   = useState("");
  const [error,   setError]   = useState(false);
  const [shake,   setShake]   = useState(false);
  const [ready,   setReady]   = useState(false); // prevents flash

  useEffect(() => {
    if (localStorage.getItem(AUTH_KEY) === "1") setAuthed(true);
    setReady(true);
  }, []);

  const attempt = () => {
    if (input === PASSWORD) {
      localStorage.setItem(AUTH_KEY, "1");
      setAuthed(true);
    } else {
      setError(true);
      setShake(true);
      setInput("");
      setTimeout(() => { setShake(false); setError(false); }, 600);
    }
  };

  if (!ready) return null;
  if (authed)  return children;

  return (
    <div style={{
      height: "100vh", width: "100vw",
      display: "flex", alignItems: "center", justifyContent: "center",
      background: "linear-gradient(160deg, #ececf0 0%, #e8e8ed 45%, #ebebf0 100%)",
      position: "relative", overflow: "hidden",
    }}>
      {/* Orbs */}
      <div style={{ position: "fixed", width: 400, height: 400, borderRadius: "50%", top: -110, left: -90, background: "radial-gradient(circle, rgba(200,200,212,0.92) 0%, transparent 65%)", pointerEvents: "none" }} />
      <div style={{ position: "fixed", width: 460, height: 460, borderRadius: "50%", bottom: -140, right: -100, background: "radial-gradient(circle, rgba(188,194,212,0.88) 0%, transparent 65%)", pointerEvents: "none" }} />

      {/* Card */}
      <div style={{
        width: 340,
        background: "rgba(255,255,255,0.58)",
        backdropFilter: "blur(40px) saturate(180%)",
        WebkitBackdropFilter: "blur(40px) saturate(180%)",
        border: "0.5px solid rgba(255,255,255,0.82)",
        borderRadius: 24,
        padding: "36px 32px 32px",
        display: "flex", flexDirection: "column", alignItems: "center",
        animation: shake ? "shake 0.5s ease" : "none",
        zIndex: 10,
      }}>
        {/* Icon */}
        <div style={{
          width: 52, height: 52, borderRadius: 16,
          background: "rgba(255,255,255,0.62)",
          border: "0.5px solid rgba(255,255,255,0.9)",
          display: "flex", alignItems: "center", justifyContent: "center",
          marginBottom: 20,
        }}>
          <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="rgba(50,60,90,0.55)" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="11" width="18" height="11" rx="2"/>
            <path d="M7 11V7a5 5 0 0110 0v4"/>
          </svg>
        </div>

        <div style={{ fontSize: 18, fontWeight: 700, color: "#1c1c1e", letterSpacing: "-0.4px", fontFamily: FF, marginBottom: 6 }}>
          QC Inc.
        </div>
        <div style={{ fontSize: 12, color: "rgba(60,60,67,0.42)", fontFamily: FF, marginBottom: 28 }}>
          Enter your password to continue
        </div>

        {/* Input */}
        <input
          type="password"
          autoFocus
          value={input}
          placeholder="Password"
          onChange={(e) => { setInput(e.target.value); setError(false); }}
          onKeyDown={(e) => e.key === "Enter" && attempt()}
          style={{
            width: "100%", boxSizing: "border-box",
            padding: "12px 14px", borderRadius: 12,
            border: error
              ? "0.5px solid rgba(200,50,40,0.4)"
              : "0.5px solid rgba(255,255,255,0.82)",
            background: "rgba(255,255,255,0.55)",
            fontSize: 14, fontFamily: FF, color: "#1c1c1e",
            outline: "none",
            transition: "border 0.15s",
            marginBottom: error ? 8 : 18,
          }}
        />

        {error && (
          <div style={{
            fontSize: 12, color: "rgba(180,40,30,0.85)", fontFamily: FF,
            marginBottom: 14, alignSelf: "flex-start",
          }}>
            Incorrect password. Try again.
          </div>
        )}

        <button
          onClick={attempt}
          style={{
            width: "100%", padding: "13px",
            background: "rgba(20,22,30,0.88)", border: "none", borderRadius: 12,
            color: "white", fontSize: 14, fontWeight: 600,
            cursor: "pointer", fontFamily: FF,
          }}
        >
          Unlock
        </button>
      </div>

      <style>{`
        @keyframes shake {
          0%,100% { transform: translateX(0); }
          20%      { transform: translateX(-8px); }
          40%      { transform: translateX(8px); }
          60%      { transform: translateX(-5px); }
          80%      { transform: translateX(5px); }
        }
      `}</style>
    </div>
  );
}
